import { render } from "./App.vue?vue&type=template&id=04eefd0a&bindings={}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/lib/bootstrap/2.3.2/css/bootstrap.min.css?vue&type=style&index=0&lang=css"
import "@/assets/lib/bootstrap/2.3.2/css/bootstrap-responsive.min.css?vue&type=style&index=1&lang=css"
import "@/assets/lib/font-awesome/3.2.1/css/font-awesome.min.css?vue&type=style&index=2&lang=css"
import "@/assets/lib/checkout-ui/v5.23.5/style/style.css?vue&type=style&index=3&lang=css"
import "@/assets/css/gt-checkout-2.css?vue&type=style&index=4&lang=css"
script.render = render

export default script